<template>
    <v-container
      class="main-container responsive-height create-investor-account-wrapper"
    >
      <v-row>
        <v-col cols="12">
          <div class="middle-bar">
            <div class="titleName mb-1">
              <v-icon class="mr-2" color="#5F7692">mdi-bag-checked</v-icon>
              <span class="text--ash">TradeMaster Investor Accounts</span>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row dense class="mt-2"> 

      <v-skeleton-loader v-if="loading" type="card" :loading="true" width="400"></v-skeleton-loader>

      <v-col  v-if="!loading" sm="6" md="6" lg="4" v-for="account in investorAccounts" :key="account.id">
        <v-card
          class="elevation-0 rounded-0 live-account-card"
          :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'"
        >
          <v-card-actions>
            <div class="trade-status">
              <div>
                <v-icon color="#647E98">mdi-currency-usd</v-icon>
              </div>
              <div class="trade-number">
                <span class="text-green">TRADEMASTER</span>
                <span>{{ account.trading_account_no }}</span>
              </div>
            </div>
            <v-spacer></v-spacer>
            <div class="trade-dropdown">
              <v-menu
                rounded="0"
                class="trade-dropdown-menu"
                transition="slide-x-transition"
                bottom
                left
              >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    small
                    tile
                    elevation="0"
                    class="ma-0 text-capitalize btn-account"
                    v-bind="attrs"
                    v-on="on"
                    icon
                  >
                    <v-icon :color="$vuetify.theme.dark ? '#fff' : '#162334'"
                      >mdi-dots-vertical</v-icon
                    >
                  </v-btn>
                </template>
                <v-card class="dropdown-menu-card" tile flat>
                  <v-list
                    flat
                    outlined
                    :color="$vuetify.theme.dark ? '#111A26' : '#F1F7FB'"
                  >
                    <v-list-item-group>
                      <v-list-item
                        v-for="(item, key) in items"
                        :key="key"
                        :ripple="false"
                        link
                      >
                        <v-list-item-content>
                          <router-link
                            v-text="item.text"
                            class="text-decoration-none"
                            router
                            :to="item.link"
                          ></router-link>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-menu>
            </div>
          </v-card-actions>
          <v-card-actions>
            <div class="value-trades mb-0">
              <span>Balance</span>
              <span>{{ account.Balance }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value-trades mb-0">
              <span>Currency</span>
              <span>{{ account.currency_name }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <v-sheet
              :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'"
            >
              <div>
                <apexChart
                  width="100%"
                  height="85px"
                  type="line"
                  :options="options"
                  :series="series"
                >
                </apexChart>
              </div>
            </v-sheet>
          </v-card-actions>
          <v-card-actions>
            <div class="currency-leverage">
              <span>Equity</span>
              <span>{{ account.Equity }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="currency-leverage">
              <span>Leverage</span>
              <span>{{ account.leverage }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <div class="balance-equity">
              <span>Free Margin</span>
              <span>{{ account.Margin }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="balance-equity">
              <span>Acc. Type</span>
              <span>{{ account.account_type_display }}</span>
            </div>
          </v-card-actions>
          <v-card-actions class="pb-0">
            <v-btn :to="`/trade-master-details/${account.id}`" block outlined class="blink"> See Details </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <span v-if="!this.investorAccounts" class="text-center">
        No Manager Found
      </span>

    </v-row>
    </v-container>
  </template>
  
<script>
import { mapState, mapActions } from "vuex";
import { TRADEMASTER__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      search: "",
      loading: false,
      slots: ["USD", "INR", "JPY"],
      items: [
        { text: "Deposit Funds", link: "/deposit" },
        { text: "Withdraw Funds", link: "/withdraw" },
        { text: "Internal Transfer", link: "/transfer-form" },
        { text: "Change Trading Password", link: "/" },
        { text: "Change Leverage", link: "/" },
        { text: "Account Detail", link: "/" },
      ],
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
      series: [
        {
          name: "Series 1",
          data: [45, 52, 38, 45, 19, 23, 2],
        },
      ],
    };
  },
  computed: {
    ...mapState("tradeMaster", [
      "investorAccounts",
    ]),
  },
  methods: {
    ...mapActions("tradeMaster", [
      TRADEMASTER__ACTIONS.INVESTORACCOUNTS,
    ]),

    async getManager(){
      try{
        this.loading = true;
        await this[TRADEMASTER__ACTIONS.INVESTORACCOUNTS]();
      }catch(error){
        console.log(error)
      }finally{
        this.loading = false;
      }
    }
  },
  async mounted() {
    this.getManager();
  },
}
</script>

<style>
.v-skeleton-loader__card-heading {
  opacity: .3 !important;
}

.v-skeleton-loader__image{
  opacity: .3 !important;
}
</style>
  